import {useEffect, useState} from "react";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";
import {AdminUserForm} from "./AdminUserForm";

// Д1 — раздел „Потребители": списък + създаване/редакция.
export const AdminUsers = () => {
    const [users, setUsers] = useState([]);
    const [error, setError] = useState('');
    const [editing, setEditing] = useState(null); // null = затворено, {} = нов, обект = редакция
    const request = requester();

    const load = async () => {
        try {
            setError('');
            const data = await request.get(`${baseUrl()}/admin/users`);
            setUsers(data);
        } catch (err) {
            setError(err.message || 'Грешка при зареждане на потребителите.');
        }
    };

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSaved = () => {
        setEditing(null);
        load();
    };

    const settlementsLabel = (u) => {
        if (u.role === 'admin') return 'всички';
        return u.settlements.length ? `${u.settlements.length} землища` : 'всички';
    };

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <h3 className="me-auto mb-0">Потребители</h3>
                {editing === null && (
                    <button className="btn btn-primary" onClick={() => setEditing({})}>
                        + Нов потребител
                    </button>
                )}
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            {editing !== null && (
                <AdminUserForm user={editing} onSaved={onSaved} onCancel={() => setEditing(null)}/>
            )}

            <table className="table table-hover align-middle">
                <thead>
                <tr>
                    <th>Потребител</th>
                    <th>Име</th>
                    <th>Роля</th>
                    <th>Справки</th>
                    <th>Землища</th>
                    <th>Последно влизане</th>
                    <th>Достъп</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {users.map(u => (
                    <tr key={u.id}>
                        <td>{u.username}</td>
                        <td>{u.full_name || "—"}</td>
                        <td>{u.role === 'admin' ? 'администратор' : 'потребител'}</td>
                        <td>{u.role === 'admin' || u.can_reports ? 'да' : 'не'}</td>
                        <td>{settlementsLabel(u)}</td>
                        <td>{u.last_login || '—'}</td>
                        <td>
                            {u.active
                                ? <span className="badge bg-success">активен</span>
                                : <span className="badge bg-secondary">спрян</span>}
                        </td>
                        <td>
                            <button className="btn btn-sm btn-outline-secondary"
                                    onClick={() => setEditing(u)}>Редакция</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};
